import angular from 'angular';
import { changePageTitle } from 'auth/actions/session.actions';

export default angular.module('rw-dashboard-routing', []).config([
  '$stateProvider',
  function configure($stateProvider) {
    $stateProvider
      .state('dashboard-summary', {
        parent: 'arw',
        url: '/dashboard-summary/:retailerNo',
        template: `<rw-dashboards subtype="summary"></rw-dashboards>`,
        redirectTo: 'home-view',
        params: {
          skipDirtyForms: false,
          pageTitle: [
            '$ngRedux',
            'gettextCatalog',
            ($ngRedux, gettextCatalog) => {
              $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('Summary Dashboard')));
            },
          ],
        },
      })
      .state('dashboard-instant', {
        parent: 'arw',
        url: '/dashboard-instant/:retailerNo',
        template: '<rw-dashboards subtype="instant"></rw-dashboards>',
        redirectTo: 'dashboard-summary',
        params: {
          skipDirtyForms: false,
          pageTitle: [
            '$ngRedux',
            'gettextCatalog',
            ($ngRedux, gettextCatalog) => {
              $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('Instants Dashboard')));
            },
          ],
        },
      })
      .state('dashboard-view-storeprofiles-summary', {
        parent: 'arw',
        url: '/dashboard-store-profile/:retailerNo',
        template: '<rw-dashboards retailer-type="STORE_PROFILE" subtype="summary"></rw-dashboards>',
        redirectTo: 'dashboard-instant',
        params: {
          skipDirtyForms: false,
          pageTitle: [
            '$ngRedux',
            'gettextCatalog',
            ($ngRedux, gettextCatalog) => {
              $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('Store Profile')));
            },
          ],
        },
      });
  },
]);



// WEBPACK FOOTER //
// ./src/modules/dashboard/rw-dashboard-routing-module.js